import React from "react"

//styles
import * as styles from "../../styles/components/menu/menuItems.module.scss"

const MenuItems = ({ categories }) => {
  return (
    <section className={styles.left}>
      {categories.map((category, index) => (
        <div key={index} style={{ marginBottom: "3rem" }}>
          <div className={styles.categoryHeading}>
            {category.image && (
              <img
                src={`${category.image}`}
                className={styles.image}
                alt=""
              />
            )}
            <h2>{category.category}</h2>
          </div>
          {category.items.map((item, index) => (
            <article className={styles.menuItem} key={index}>
              <div className={styles.itemName}>{item.name}</div>
              <strong>{item.price}MZN</strong>
              {item.description && (
                <p className={styles.itemDescription}>{item.description}</p>
              )}
            </article>
          ))}
        </div>
      ))}
    </section>
  )
}

export default MenuItems
